'use client';

import React, { useState, useEffect } from 'react';
import { PackageSearch, Clock, CheckCircle2, AlertCircle } from 'lucide-react';

export default function GRNHeader() {
  const [dateStr, setDateStr] = useState('');
  const [timeStr, setTimeStr] = useState('');

  useEffect(() => {
    const now = new Date();
    setDateStr(now?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }));
    setTimeStr(now?.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }));

    const interval = setInterval(() => {
      const n = new Date();
      setDateStr(n?.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }));
      setTimeStr(n?.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true }));
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <header className="flex items-center justify-between px-6 py-4 border-b border-border bg-card flex-shrink-0">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-lg bg-primary/15 flex items-center justify-center">
          <PackageSearch size={20} className="text-primary" />
        </div>
        <div>
          <h1 className="text-base font-bold text-foreground tracking-tight">Inbound / GRN Registration</h1>
          <p className="text-2xs text-muted-foreground">Receive goods · Generate GRN · Initialize Quarantine</p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {/* Stats row */}
        <div className="hidden md:flex items-center gap-4">
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-muted/50">
            <CheckCircle2 size={13} className="text-green-400" />
            <span className="text-xs text-muted-foreground">Today:</span>
            <span className="text-xs font-bold text-foreground">12 GRNs</span>
          </div>
          <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-muted/50">
            <AlertCircle size={13} className="text-accent" />
            <span className="text-xs text-muted-foreground">Pending QC:</span>
            <span className="text-xs font-bold text-accent">7</span>
          </div>
        </div>

        {/* Date/time */}
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Clock size={13} />
          <span>{dateStr && timeStr ? `${dateStr} · ${timeStr}` : ''}</span>
        </div>
      </div>
    </header>
  );
}
